import React from 'react';
import "./style.css";

function Footer() {
    return (
        <footer>
            <p className="container-fluid footer"> Copyright © 2021 Rocco Losito</p>
        </footer>
    );
};

export default Footer;